import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { TopBarView } from "./TopBar";
import "../Reset.css";
import "./Maintenance.css";
export const MaintenanceView = (props) => {
    return (_jsxs(_Fragment, { children: [_jsx(TopBarView, { BarSelect: 0 }), _jsx("div", Object.assign({ id: "M1" }, { children: _jsxs("div", Object.assign({ id: "M2" }, { children: [_jsx("span", Object.assign({ id: "MaintenanceSpan1" }, { children: "The GTD configurator is under maintenance" })), _jsx("span", Object.assign({ id: "MaintenanceSpan2" }, { children: "Please check back again later" }))] })) }))] }));
};
